<template>

    <div>
        <div
            class="mb-5"
            v-if="category.data && category.data.headContent && category.data.headContent !== ''"
        >
            <div class="container">
                <div v-html="category.data.headContent"></div>
            </div>
        </div>
        <div class="container">
            <div class="row productscontainer">
                <div
                    v-if="products.data.length === 0"
                    class="text-center"
                >
                    <p v-html="lang('products.overview.no-products')"></p>
                </div>
                <div
                    v-for="product in products.data"
                    class="col-6 col-md-4 col-lg-3"
                >
                    <overview-item
                        :product="product"
                    ></overview-item>
                </div>
            </div>

            <div
                v-if="products.meta && products.meta.last_page > 1"
                class="mt-5"
            >
                <pagination
                    :meta="products.meta"
                    :links="products.links"
                ></pagination>
            </div>
        </div>
        <div
            class="pagecontent mt-5"
            v-if="category.data && category.data.content && category.data.content !== ''"
        >
            <div class="container">
                <div v-html="category.data.content"></div>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";
import OverviewItem from "../../../components/Products/OverviewItem";
import Pagination from "../../../components/Pagination.vue";

export default {

    components: {
        OverviewItem,
        Pagination,
    },

    destroyed(){
        this.$pageTitleImage.remove();
        this.$pageHeader.show();
    },

    layout:Layout,

    metaInfo() {
        return {
            title: this.category.data.pagetitle,
            meta: [
                { name: 'description', content: this.category.data.meta_description },
                { name: 'keywords', content: this.category.data.meta_keywords },
            ],
        }
    },

    mounted(){
        if (this.category.data.headContent) {
            this.$pageHeader.hide();
        }

        if (this.category.data.image) {
            this.$pageTitleImage.set(this.category.data.image.url);
        }
        this.$GA4.dispatch('view_item_list');
    },

    name:'OpenCategoriesShow',

    props: {
        category: {
            required:true,
        },
        products: {
            required:true,
        },
    },

}

</script>
